import React from "react";
import { Tooltip } from "@tvg/design-system";
import { formatPurse, formatCurrencyShortened } from "@tvg/formatter/currency";
import { TooltipWrapper, TooltipContent } from "../styled-components";

interface Props {
  amount: number;
}

const TooltipExceededAmounts = ({ amount }: Props) => (
  <TooltipWrapper>
    <Tooltip
      qaLabel="tooltip-amount"
      content={formatCurrencyShortened(amount)}
      placement="bottom-mid"
    >
      <TooltipContent data-qa-label="formatted-amount">
        {formatPurse(amount)}
      </TooltipContent>
    </Tooltip>
  </TooltipWrapper>
);

export default TooltipExceededAmounts;
